import { Component, Input } from "@angular/core";

@Component({
    selector:'service-and-contact-component',
    templateUrl:'./service-and-contact.component.html',
    styleUrls:['./service-and-contact.component.scss']
})
export class ServiceAndContactComponent {
    phoneNumbers = ['09 255587664', '09 448489779'];
}